// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Widget__Edit__Component[data-v-cfbc25a8] {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
